<template>
    <x-dialog custom-class="x-file-preview" :visible="visible" :config="getDialogConfig(config)" @close="$emit('close')"
        @update:visible="(visible) => $emit('update:visible', visible)">
        <div class="x-login">
            <div>
                <div class="loginForm" style="width: 550px" @keydown.enter="login()" v-if="!agreement">
                    <div style="width: 100%;position: relative;">
                        <div style="position: absolute;padding: 10px;right: 0px;cursor: pointer;">
                            <el-icon style="font-size: 18px;" @click="onClose">
                                <Close />
                            </el-icon>
                        </div>
                        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick" :lazy="false">
                            <template #addIcon>

                            </template>
                            <el-tab-pane label="密码登录" name="password">
                                <el-form style="width: 358px" label-width="0" class="form">
                                    <el-form-item>
                                        <div style="
                                                display: flex;
                                                justify-content: center;
                                                align-items: center;
                                                width: 100%;
                                                margin-top: 20px;
                                                font-size: 18px;
                                            ">
                                            <span>爱婴医院妇幼保健人员岗位胜任力考核中心</span>
                                        </div>
                                        <div style="
                                                display: flex;
                                                justify-content: center;
                                                align-items: center;
                                                width: 100%;
                                                font-weight: 500;
                                            "></div>
                                    </el-form-item>
                                    <el-form-item style="padding: 5px; margin-top: 10px">
                                        <el-input ref="loginId" :prefix-icon="User" v-model="form.loginId"
                                            placeholder="输入登录账户" @input="usernameInvalid = false" />
                                        <el-tooltip placement="left" v-model:visible="usernameInvalid" :popper-options="{
                                            modifiers: [
                                                {
                                                    name: 'computeStyles',
                                                    options: {
                                                        adaptive: false,
                                                        enabled: false
                                                    }
                                                }
                                            ]
                                        }" :virtual-ref="usernameRef" virtual-triggering trigger="click"
                                            popper-class="singleton-tooltip">
                                            <template #content>
                                                <span style="font-size: 14px">请输入用户名</span>
                                            </template>
                                        </el-tooltip>
                                    </el-form-item>
                                    <el-form-item style="padding: 5px; margin-bottom: 5px">
                                        <el-input ref="password" :prefix-icon="Lock" type="password" v-model="form.password"
                                            placeholder="输入登录密码" @input="passwordInvalid = false" />
                                        <el-tooltip placement="left" v-model:visible="passwordInvalid" :popper-options="{
                                            modifiers: [
                                                {
                                                    name: 'computeStyles',
                                                    options: {
                                                        adaptive: false,
                                                        enabled: false
                                                    }
                                                }
                                            ]
                                        }" :virtual-ref="passwordRef" virtual-triggering trigger="click"
                                            popper-class="singleton-tooltip">
                                            <template #content>
                                                <span style="font-size: 14px">请输入密码</span>
                                            </template>
                                        </el-tooltip>
                                    </el-form-item>
                                    <el-form-item class="checkbox">
                                        <el-checkbox v-model="form.agree" label="">
                                        </el-checkbox>
                                        <span>我已阅读并同意</span>
                                        <span class="link" @click="changepactShow('《服务协议》', 'service')">《服务协议》</span>与<span
                                            class="link" @click="changepactShow('《隐私条款》', 'privacy')">《隐私条款》</span>

                                    </el-form-item>
                                    <el-form-item>
                                        <vertify></vertify>
                                    </el-form-item>
                                    <el-form-item>
                                        <div style="
                                                text-align: center;
                                                width: 100%;
                                                margin-top: 30px;
                                            ">

                                            <el-button native-type="submit" type="primary" style="
                                                    width: 130px;
                                                    border-radius: 20px;
                                                    font-size: 15px;
                                                " :loading="loginLoading" @click.prevent="() => login('password')
                                                    ">登 录</el-button>
                                        </div>
                                    </el-form-item>

                                    <el-row> </el-row>
                                </el-form>
                            </el-tab-pane>
                            <el-tab-pane label="手机验证码登录" name="phone">
                                <el-form style="width: 358px" label-width="0" class="form">
                                    <el-form-item>
                                        <div style="
                                                display: flex;
                                                justify-content: center;
                                                align-items: center;
                                                width: 100%;
                                                margin-top: 20px;
                                                font-size: 18px;
                                            ">
                                            <!-- <el-image style="width:88px; height:57px; margin:0 12px" src="/assets/login_logo.jpg" fit="contain"></el-image> -->
                                            <span>爱婴医院妇幼保健人员岗位胜任力考核中心</span>
                                        </div>
                                        <div style="
                                                display: flex;
                                                justify-content: center;
                                                align-items: center;
                                                width: 100%;
                                                font-weight: 500;
                                            ">
                                        </div>
                                    </el-form-item>
                                    <el-form-item style="padding: 5px; margin-top: 10px">
                                        <el-input ref="phone" :prefix-icon="Iphone" v-model="phoneForm.loginId"
                                            placeholder="输入手机号" @input="phoneInvalid = false" />
                                        <el-tooltip placement="left" v-model:visible="phoneInvalid" :popper-options="{
                                            modifiers: [
                                                {
                                                    name: 'computeStyles',
                                                    options: {
                                                        adaptive: false,
                                                        enabled: false
                                                    }
                                                }
                                            ]
                                        }" :virtual-ref="phoneRef" virtual-triggering trigger="click"
                                            popper-class="singleton-tooltip">
                                            <template #content>
                                                <span style="font-size: 14px">请输入手机号</span>
                                            </template>
                                        </el-tooltip>
                                    </el-form-item>
                                    <!-- <el-form-item style="padding: 5px; margin-bottom: 5px">
                  <el-slider v-model="value1" />
                </el-form-item> -->
                                    <el-form-item style="padding: 5px; margin-bottom: 5px">
                                        <div style="
                                                width: 100%;
                                                display: flex;
                                                flex-direction: row;
                                                margin-bottom: 5px;
                                            ">
                                            <el-input ref="code" :prefix-icon="ChatSquare" type="text" v-model="phoneForm.verificationCode
                                                " placeholder="输入手机验证码" @input="codeInvalid = false" />
                                            <el-button v-if="eRcode" :disabled="!disabled" style="margin-left: 10px"
                                                @click="getCode">获取验证码</el-button>
                                            <el-button v-else disabled style="margin-left: 10px">剩余{{ time }}秒</el-button>
                                            <el-tooltip placement="left" v-model:visible="codeInvalid" :popper-options="{
                                                modifiers: [
                                                    {
                                                        name: 'computeStyles',
                                                        options: {
                                                            adaptive: false,
                                                            enabled: false
                                                        }
                                                    }
                                                ]
                                            }" :virtual-ref="codeRef" virtual-triggering trigger="click"
                                                popper-class="singleton-tooltip">
                                                <template #content>
                                                    <span style="font-size: 14px">请输入手机验证码</span>
                                                </template>
                                            </el-tooltip>
                                        </div>
                                    </el-form-item>
                                    <el-form-item class="checkbox">
                                        <el-checkbox v-model="form.agree" label="">
                                        </el-checkbox>
                                        <span>我已阅读并同意</span>
                                        <span class="link" @click="changepactShow('《服务协议》', 'service')">《服务协议》</span>与<span
                                            class="link" @click="changepactShow('《隐私条款》', 'privacy')">《隐私条款》</span>
                                    </el-form-item>
                                    <!-- <el-form-item>
                                    <div style="height: 14px"></div>
                                </el-form-item> -->
                                    <el-form-item>
                                        <div style="
                                                text-align: center;
                                                width: 100%;
                                                margin-top: 30px;
                                            ">
                                            <el-button native-type="submit" type="primary" style="
                                                    width: 130px;
                                                    border-radius: 20px;
                                                    font-size: 15px;
                                                " :loading="loginLoading" @click.prevent="() => login('phone')
                                                    ">登 录</el-button>
                                        </div>
                                    </el-form-item>

                                    <el-row> </el-row>
                                </el-form>
                            </el-tab-pane>

                        </el-tabs>
                    </div>
                </div>
            </div>
            <div class="content_pact" v-if="pactShow">
                <div class="a001">
                    <div class="b001 flex justify-content-between">
                        <div></div>
                        <div class="c001 font-size-20 font-weight-600">{{ pactTitle }}</div>
                        <div class="iconfont icon-guanbi" @click="pactShow = false"></div>
                    </div>
                    <div class="content">
                        <div class="detail" v-html="pactText">

                        </div>
                        <div class="next_btn">
                            <button class="btn font-size-20" @click="pactShow = false">同意</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="x-code">
                <Vcode :show="isShow" @success="onSuccess" />
            </div>
        </div>

    </x-dialog>
</template>
<script setup lang="ts">
import { getCurrentInstance, onMounted } from 'vue';
import { Base64 } from 'js-base64';
import XDialog from '../../dialog/XDialog.vue';
import { reactive, ref } from "@vue/reactivity";
import { User, Lock, Close, ChatSquare, Iphone } from "@element-plus/icons-vue";
import { remoteCall } from "../../remoteservice/RemoteService";
import axios from "axios";
import { ElMessageBox, ElMessage } from "element-plus";
import { handleTree } from "../../utils/dict";
import { useTokenStore } from "../../store/TokenStore";
import Vcode from "vue3-puzzle-vcode";
import { sm3Encode } from "../../utils/sm3";
// import { useRouter } from 'vue-router';
import { addURLParams } from "../../tools/URLTools";
import ModuleCenter from "../../datamodule/ModuleCenter";
import { genFileId } from "element-plus";
import { useRoute } from 'vue-router'
import md5 from "js-md5";
const pactShow = ref(false)
const pactTitle = ref('')
const pactText = ref('')
const route = useRoute();
const inst = getCurrentInstance();
const props = defineProps({
    visible: { default: true },
    uri: { default: null },
    fileName: { default: null },
    config: { default: {} },
    onClose: {
        default: () => {
        }
    }
})

defineEmits({
    'close': null,
    'update:visible': null,
})




const getDialogConfig = (config) => {
    if (!config) return null;
    if (!config.width) config.width = 800;
    config.withDefaultButtons = false;
    config.title = ' ';
    config.fullscreen = true;
    return config;
}



const type = ref("");
const isShow = ref(false);
const registerRemarker = ref(false);
const agreement = ref(false);
const tokenStore = useTokenStore();
const under = ref(false);
const addessdisabled = ref(true);
const otherdisabled = ref(true);
const token = ref(
    "Bearer eyJhbGciOiJIUzUxMiJ9.eyJjb21wYW55SWQiOm51bGwsInNyY19zeXN0ZW0iOiJsbXN5dyIsInVzZXJfaWQiOjE5NywicGNvZGUiOiJsbXMiLCJze"
);
const disabled = ref(true);
const eRcode = ref(true);
const time = ref("120");
const activeName = ref("password");
// const router = useRouter();
const register = ref(false);
const phoneForm = ref({
    loginId: "",
    verificationCode: ""
});
onMounted(async () => {
    usernameRef.value = (inst.refs.loginId as any).ref;
    passwordRef.value = (inst.refs.password as any).ref;
    phoneRef.value = (inst.refs.phone as any).ref;
    codeRef.value = (inst.refs.code as any).ref;
    autoLogin.value = !!localStorage.getItem("auto-login");
});
const getUserInfo = async () => {
    return remoteCall(
        "/dev-api/system/user/getInfo",
        { loadingState: 1 },
        true
    );
};
const usernameRef = ref(null);
const passwordRef = ref(null);
const phoneRef = ref(null);
const codeRef = ref(null);

const usernameInvalid = ref(false);
const passwordInvalid = ref(false);
const phoneInvalid = ref(false);
const codeInvalid = ref(false);
// 登录按钮loading状态
const fileList = ref([]);
const loginLoading = ref(false);
const fileName = ref("");
const validate = () => {
    let valid = true;
    if (form.loginId == "") {
        usernameInvalid.value = true;
        valid = false;
    }
    if (form.password == "") {
        passwordInvalid.value = true;
        valid = false;
    }
    return valid;
};
const sysProtocolConfig = ModuleCenter.getModule('sysProtocolConfig')
const changepactShow = async (title, type) => {
    pactText.value = ((await sysProtocolConfig.queryDatas({ query: { protocolType: type } }))[0] || {}).protocolDetail;
    // if (type == 5) {
    //     pactText.value = privacyText.value.
    // } else if (type == 6) {
    //     pactText.value = serviceText.value.protocolDetail
    // } else{
    //     pactText.value = serviceText.value.protocolDetail
    // }
    pactTitle.value = title
    pactShow.value = true
}
const phoneValidate = () => {
    let valid = true;
    if (phoneForm.value.loginId == "") {
        phoneInvalid.value = true;
        valid = false;
    }
    if (phoneForm.value.verificationCode == "") {
        codeInvalid.value = true;
        valid = false;
    }
    return valid;
};

const login = (t) => {
    type.value = t;
    console.log(type);
    if (!form.agree) {
        ElMessageBox.alert("请勾选《服务协议》与《隐私条款》", "提示", {
            type: "warning"
        });
        return;
    }

    // loginType 区分PC端和移动
    if (type.value == "password") {
        if (!validate()) return;
        loginLoading.value = true;
        let pwd = md5(form.password).toUpperCase();
        let pcode = "tat";
        let systemCode = "tatweb";
        axios
            .post("/dev-api/auth/login", {
                loginId: form.loginId,
                password: pwd,
                pcode,
                systemCode,
                source:'buy'
            })
            .then(
                (res) => {
                    // console.log(res.data.data.token)
                    if (res.data.code != "200") {
                        ElMessageBox.alert(res.data.msg, "登录失败", {
                            type: "warning"
                        });
                        return;
                    }
                    const userInfo = { token: res.data.data.access_token };
                    tokenStore.setToken(res.data.data.access_token);
                    sessionStorage.setItem("title", "爱婴医院妇幼保健人员岗位胜任力培训与考核");
                    getUserInfo().then((data) => {
                        userInfo["userId"] = data.user.userId;
                        userInfo["userName"] = data.user.userName; userInfo["nickName"] = data.user.nickName;
                        userInfo["roles"] = data?.user?.roles;
                        userInfo["scope"] = data.user.scope;
                        userInfo["userDept"] = data.userDept;
                        userInfo["user"] = data.user;
                        sessionStorage.setItem(
                            "user-info",
                            JSON.stringify(userInfo)
                        );
                        localStorage.setItem(
                            "user-info",
                            JSON.stringify(userInfo)
                        );
                        localStorage.setItem("token", userInfo.token);
                        if (autoLogin.value)
                            saveLoginInfo(form.loginId, form.password);
                        else {
                            localStorage.removeItem("auto-login");
                        }
                        setTimeout(() => {
                            // router.push('/')
                            window.location.reload();
                            // window.location.href = "/#/tatweb/post";
                        }, 1000);
                    });

                    // console.log('user-info')
                },
                (err) => {
                    console.log(err);
                    ElMessageBox.alert(
                        "用户名或密码有误，请重新登录",
                        "登陆失败",
                        {
                            type: "warning"
                        }
                    );
                    // (inst.refs.loginId as any).focus();
                }
            )
            .finally(() => {
                setTimeout(() => {
                    loginLoading.value = false;
                }, 1000);
            });
    } else if (type.value == "phone") {
        if (!phoneValidate()) return;
        loginLoading.value = true;
        let pcode = "tat";
        let systemCode = "tatweb";
        axios
            .post("/dev-api/auth/login", {
                loginId: phoneForm.value.loginId,
                verificationCode: phoneForm.value.verificationCode,
                pcode,
                systemCode,
                source:'buy'
            })
            .then(
                (res) => {
                    // console.log(res.data.data.token)
                    if (res.data.code != "200") {
                        ElMessageBox.alert(res.data.msg, "登录失败", {
                            type: "warning"
                        });
                        return;
                    }
                    const userInfo = { token: res.data.data.access_token };
                    tokenStore.setToken(res.data.data.access_token);
                    sessionStorage.setItem("title", "爱婴医院妇幼保健人员岗位胜任力培训与考核");
                    getUserInfo().then((data) => {
                        userInfo["userId"] = data.user.userId;
                        userInfo["userName"] = data.user.userName; userInfo["nickName"] = data.user.nickName;
                        userInfo["roles"] = data?.user?.roles;
                        userInfo["scope"] = data.user.scope;
                        userInfo["userDept"] = data.userDept;
                        userInfo["user"] = data.user;
                        sessionStorage.setItem(
                            "user-info",
                            JSON.stringify(userInfo)
                        );
                        localStorage.setItem(
                            "user-info",
                            JSON.stringify(userInfo)
                        );
                        localStorage.setItem("token", userInfo.token);
                        if (autoLogin.value)
                            saveLoginInfo(form.loginId, form.password);
                        else {
                            localStorage.removeItem("auto-login");
                        }
                        setTimeout(() => {
                            // router.push('/')
                            window.location.reload();
                            // window.location.href = "/#/tatweb/post";
                        }, 1000);
                    });
                },
                (err) => {
                    console.log(err);
                    ElMessageBox.alert(
                        "用户名或密码有误，请重新登录",
                        "登陆失败",
                        {
                            type: "warning"
                        }
                    );
                    // (inst.refs.loginId as any).focus();
                }
            )
            .finally(() => {
                setTimeout(() => {
                    loginLoading.value = false;
                }, 1000);
            });
    }

    // sm3Encode().substring(0, 16)
};
const onSuccess = async () => {
    isShow.value = false;
    eRcode.value = false;
    disabled.value = false;
    console.log(phoneForm.value.loginId);
    let clock = window.setInterval(() => {
        time.value--;
        if (time.value < 1) {
            window.clearInterval(clock);
            eRcode.value = true;
            disabled.value = true;
            time.value = 120;
        }
    }, 1000);
    let per = {
        loginId: phoneForm.value.loginId,
        pcode: "tat",
        systemCode: "tatweb",
        templateCode:"SMS_168710114"
    };
    const resUrl = await remoteCall(
        "/dev-api/system/sysSmsCode/sendCode",
        { data: per },
        true
    );
};
const autoLogin = ref(false);
const saveLoginInfo = (loginId, password) => {
    localStorage.setItem(
        "auto-login",
        JSON.stringify({ loginId: loginId, password: password })
    );
};

const form = reactive({
    loginId: "",
    password: ""
});
const getCode = async () => {
    if (phoneForm.value.loginId == "") {
        ElMessage.error("请输入手机号码！");
        return;
    }
    isShow.value = true;
};
</script>

<style>
html,
body {
    margin: 0;
    width: 100%;
    height: 100%;
}
</style>

<style scoped>
.x-login {
    /* position: absolute; */
    width: 100%;
    min-height: 100%;
    /* height: 100%; */
    display: flex;
    align-items: center;
    justify-content: center;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
}

.x-code>>>.vue-puzzle-vcode {
    z-index: 10000 !important;
}

>>>.el-overlay {
    z-index: 666 !important;
}

.x-login>div {
    /* padding: 0 60px;
    background: #fff; */
    /* border-radius: 20px;
    display: flex;
    box-shadow: 2px 2px 18px #00000077; */
}

.loginForm>>>.el-tabs__active-bar {
    background-color: #f07265 !important;
}

.loginForm>>>.el-tabs__item {
    font-size: 17px !important;
}

.loginForm>>>.el-tabs__item.is-active {
    color: #f07265 !important;
}

.loginForm>>>.el-tabs__item:hover {
    color: #f07265 !important;
}

.imageForm {
    width: 300px;
    height: 480px;
    pointer-events: none;
}

.download:hover {
    cursor: pointer;
    color: #ff6333;
}

.imageForm>div {
    width: 100%;
    height: 100%;
}

.loginForm {
    width: 400px;
    height: 480px;
    display: flex;
    /* justify-content: center;
  align-items: center; */
    background: #fff;
}

.loginForm>>>.demo-tabs {
    width: 90%;
    margin-left: 5%;
    margin-top: 10px;
}

.loginBtn {
    width: 100px;
}

.checkBox {
    margin-left: 7px;
}

.inpWidth {
    width: 165px;
}

.floatR {
    font-size: 10px;
    margin-left: 9px;
    color: blue;
}

.x-login {
    /* --el-menu-bg-color: #173a66;
    --el-menu-border-color: #173a66;
    --el-menu-hover-bg-color: #2168c2;
    --el-color-primary: #20518f; */
}

.x-login>>>.el-input {
    --el-input-focus-border-color: #4666ee;
}

.x-login>>>.el-menu {
    --el-text-color-primary: #ffffff;
    --el-menu-text-color: var(--el-text-color-primary);
}

.x-login>>>.el-button {
    --el-border: 1px solid #dcdee0;
    --el-button-border: #f07265;

    --el-color-primary: #5079ec;
    --el-color-primary-light-9: #e0e7ef;
    --el-color-primary-light-7: #4666ee;
}

.x-login>>>.el-button--primary {
    --el-button-bg-color: #5079ec;
    --el-border: 1px solid #20518f;
    --el-button-border: #20518f;

    --el-color-primary: #5079ec;
    --el-color-primary-light-5: #8fa8c7;
    --el-color-primary-light-3: #4666ee;
    --el-color-primary-dark-2: #3d51a9;
}

.x-login>>>.x-table-list>.x-button-group>.el-button--primary,
.x-home>>>.x-form-list>.x-button-group>.el-button--primary {
    --el-button-bg-color: #ffffff;
    --el-border: 1px solid #dcdee0;
    --el-button-border: #dcdee0;

    --el-color-primary: #5079ec;
    --el-color-primary-light-9: #e0e7ef;
    --el-color-primary-light-7: #89a1c0;
    --el-button-text-color: var(--el-color-primary);
    --el-button-hover-bg-color: var(--el-button-bg-color);
    --el-button-hover-text-color: var(--el-color-primary-light-7);
    --el-button-hover-border-color: var(--el-color-primary-light-7);
    --el-button-active-bg-color: var(--el-color-primary-light-9);
    --el-button-active-text-color: var(--el-color-primary);
    --el-button-active-border-color: var(--el-color-primary);
}

.form {
    margin: 0 auto;
    /*  min-height: 500px;
  padding: 40px;
  min-width: 800px; */
    background: #fff;
}

.formregister {
    margin: 0 auto;
    min-height: 500px;
    padding: 40px;
    min-width: 800px;
    background: #fff;
    position: relative;
}

.el-form-item {
    margin-bottom: 20px;
    /* 调整 el-form-item 之间的底部间距 */
}

.formregister>>>.el-form-item__content {
    /* margin-top:20px !important; */
    margin-left: 0 !important;
}

.formregister>>>.el-upload__tip {
    margin-top: 0px !important;
    margin-left: 20px !important;
}

.link {
    cursor: pointer;
    color: darkgoldenrod;
}

.content_pact {
    width: 100%;
    height: 100%;
    position: fixed;
    background: rgba(0, 0, 0, 0.6);
    left: 0;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;


}

.content_pact .a001 {
    width: 1100px;
    height: 750px;
    border-radius: 10px;
    background: #fff;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    text-align: center;
    overflow: hidden;


}

.content_pact .a001 .content {
    padding: 20px 50px;


}

.content_pact .a001 .content .detail {
    height: 550px;
    overflow: auto;
    text-align: left;
}

.next_btn {}

.btn {
    width: 200px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    border-radius: 30px;
    font-size: 20px;
    font-weight: 600;
    margin: 40px auto;
    color: #fff;
    background-color: #E4151B;
}

.btn:hover {
    cursor: pointer;
    color: #fff;
    font-weight: 600;
    background-color: #7ea6f0;
}

.content_pact .a001 .b001 {
    height: 65px;
    line-height: 65px;
    font-size: 20px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    padding: 0 20px;
    position: relative;
    color: #fff;
    background-color: #E4151B;


}

.iconfont {
    line-height: 65px;
    font-size: 20px;
}

.content_pact .a001 .b001 .c002 {
    width: 30px;
    height: 30px;
    margin: auto 0;
    cursor: pointer;
}
</style>

<style>
.x-file-preview {
    background: #00000099;
}

.x-file-preview .el-dialog__title {
    color: #fff;
}
</style>
